'use client'

import React from 'react'

export interface DashboardHeaderProps {
  title: string
  /**
   * The avatar/profile control. A slot rather than an import, because
   * ProfileAvatar calls useTranslations and only one of the two dashboards
   * mounts a next-intl provider — each app passes whatever it can render.
   */
  profileSlot?: React.ReactNode
  actions?: React.ReactNode
}

/** The desktop title bar. 48px, sticky, above the page content. */
export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  profileSlot,
  actions,
}) => (
  <div className="w-full h-12 px-7 bg-[#F7F7F3] border-b border-gray-300 flex justify-between items-center relative z-50">
    <div className="text-dashboard-text text-[13px] font-medium leading-tight">{title}</div>
    <div className="flex items-center gap-4">
      {actions}
      {profileSlot}
    </div>
  </div>
)
